import {
  Button,
  ButtonGroup,
  H2,
  Modal,
  TextInput,
} from "@datapay-by-datacom/design-system";
import { useRef, useState } from "react";
import {
  OrgCategory,
} from "../../../generated/core-api";
import { OrgInviteCreateForm } from "./OrgInviteCreateForm";

interface OrgInviteCreateModalProps {
  category: OrgCategory;
  id: string;
  isOpen: boolean;
  onClose: () => void;
}

export function OrgInviteCreateModal({
  category,
  id,
  isOpen,
  onClose,
}: OrgInviteCreateModalProps) {
  const [invitationLink, setInvitationLink] = useState<string | null>(null);
  const [isCopied, setIsCopied] = useState(false);
  const linkRef = useRef<HTMLInputElement>(null);

  const handleCopyLink = () => {
    if (linkRef.current) {
      linkRef.current.select();
      document.execCommand("copy");
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 3000);
    }
  };

  const handleSuccess = (link: string) => {
    setInvitationLink(link);
  };

  const handleReset = () => {
    setInvitationLink(null);
    setIsCopied(false);
  };

  const handleClose = () => {
    onClose();
    handleReset();
  };

  return (
    <Modal isOpen={isOpen}>
      <div style={{ padding: "30px 20px", maxWidth: "500px" }}>
        <H2 style={{ marginBottom: "20px" }}>Create Invitation</H2>

        {invitationLink ? (
          <div style={{ marginTop: "20px", marginBottom: "20px" }}>
            <p>
              Invitation created successfully! Share this link with the
              recipient:
            </p>
            <div
              style={{
                display: "flex",
                marginTop: "10px",
                marginBottom: "15px",
              }}
            >
              <TextInput
                ref={linkRef}
                value={invitationLink}
                isReadOnly
                style={{ flexGrow: 1 }}
              />
              <Button
                variant="secondary"
                onPress={handleCopyLink}
                style={{ marginLeft: "10px" }}
              >
                {isCopied ? "Copied!" : "Copy"}
              </Button>
            </div>
            <p style={{ fontSize: "0.9em", color: "#666" }}>
              This is a one-time use link that will expire after it's been used.
            </p>
            <div style={{ marginTop: "20px" }}>
              <ButtonGroup>
                <Button variant="tertiary" onPress={handleClose}>
                  Close
                </Button>
                <Button variant="primary" onPress={handleReset}>
                  Create Another
                </Button>
              </ButtonGroup>
            </div>
          </div>
        ) : (
          <OrgInviteCreateForm
            category={category}
            id={id}
            onSuccess={handleSuccess}
            onCancel={handleClose}
          />
        )}
      </div>
    </Modal>
  );
}
